if (!customElements.get('usp-grid')) {
  customElements.define('usp-grid', class extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('.usp-list');
      this.navigation = this.querySelector('.usp-section__navigation');
      this.previous = this.querySelector('.usp-section__arrow--previous');
      this.next = this.querySelector('.usp-section__arrow--next');
      this.mobile = window.matchMedia('(max-width: 767px)');
      this.abortController = new AbortController();
      const { signal } = this.abortController;

      this.update = () => {
        const maxScroll = this.list.scrollWidth - this.list.clientWidth;
        const enabled = this.mobile.matches && maxScroll > 1;
        this.list.tabIndex = enabled ? 0 : -1;
        this.navigation.hidden = !enabled;
        const position = Math.abs(this.list.scrollLeft);
        this.previous.setAttribute('aria-disabled', String(position <= 1));
        this.next.setAttribute('aria-disabled', String(position >= maxScroll - 1));
      };

      [this.previous, this.next].forEach((button, index) => {
        button.addEventListener('click', () => {
          if (button.getAttribute('aria-disabled') === 'true') return;
          const direction = getComputedStyle(this.list).direction === 'rtl' ? -1 : 1;
          const maxScroll = this.list.scrollWidth - this.list.clientWidth;
          const items = this.list.children;
          const step = items.length > 1
            ? Math.abs(items[1].offsetLeft - items[0].offsetLeft)
            : this.list.clientWidth;
          const position = Math.abs(this.list.scrollLeft) + (index === 0 ? -step : step);
          this.list.scrollTo({ left: direction * Math.max(0, Math.min(maxScroll, position)), behavior: 'instant' });
          this.update();
        }, { signal });
      });
      this.list.addEventListener('scroll', () => {
        if (this.frame) return;
        this.frame = requestAnimationFrame(() => {
          this.frame = null;
          this.update();
        });
      }, { passive: true, signal });
      this.mobile.addEventListener('change', this.update, { signal });
      this.resizeObserver = new ResizeObserver(this.update);
      this.resizeObserver.observe(this.list);
      this.update();
    }

    disconnectedCallback() {
      this.abortController.abort();
      this.resizeObserver.disconnect();
      cancelAnimationFrame(this.frame);
    }
  });
}
